import { active } from "@api/productPlans/active/api";
import { deactive } from "@api/productPlans/deactive/api";
import { createGetAllApi } from "@api/util/createGetAllApi";
import { createGetApi } from "@api/util/createGetApi";
import { createPatchApi } from "@api/util/createPatchApi";
import { createPostApi } from "@api/util/createPostApi";

import type { IApiResponse, IPagination, IPaginationParams } from "@api";

import type { IPathBaseParam, IPathByIdParam } from "./path";
import type {
  IProductPlansDto,
  IProductPlansGetAllParams,
  IProductPlansResponse,
} from "./types";

const getAllApis = createGetAllApi<
  IApiResponse<IPagination<IProductPlansResponse>>,
  IPathBaseParam,
  IPaginationParams & IProductPlansGetAllParams
>("productPlans");
const postApis = createPostApi<
  IApiResponse<IProductPlansResponse>,
  IPathBaseParam,
  IProductPlansDto
>("productPlans");
const getApis = createGetApi<
  IApiResponse<IProductPlansResponse>,
  IPathByIdParam,
  object
>("productPlans");
const patchApis = createPatchApi<
  IApiResponse<IProductPlansResponse>,
  IPathByIdParam,
  IProductPlansDto
>("productPlans");

export const productPlans = {
  ...getAllApis,
  ...getApis,
  ...postApis,
  ...patchApis,
  active,
  deactive,
};
